import React, { useState, useRef } from 'react'
import PrimaryButton from './PrimaryButton'
import swal from 'sweetalert';
import emailjs from 'emailjs-com';
import styled from 'styled-components';

const ContactFormStyled = styled.section`
    .contact-title{
        h4{
            color: var(--white-color);
            padding: 1rem 0;
            font-size: 1.8rem;
        }
    }
    .form{
        width: 100%;
        @media screen and (max-width: 502px){
            width: 94%;
        }
        .form-field{
            margin-top: 2rem;
            position: relative;
            width: 100%;
            label{
                position: absolute;
                left: 20px;
                top: -19px;
                display: inline-block;
                background-color: var(--background-dark-color);
                padding:0 .5rem;
                color: inherit;
            }
            input{
                border: 1px solid var(--border-color);
                outline: none;
                background: transparent;
                height: 50px;
                padding:0 15px;
                width: 100%;
                color: inherit;
            }
            textarea{
                background-color: transparent;
                border: 1px solid var(--border-color);
                outline: none;
                color: inherit;
                width: 100%;
                padding: .8rem 1rem;
                resize:vertical;
            }
        }
    }
`;


const ContactForm = () => {
    const formRef = useRef()

    const obj = { user_name: "", user_email: "", user_phone: "", message: "", }
    const [user, setUser] = useState(obj)
    const { user_name, user_email, user_phone, message } = user

    const handleChange = (event) => {
        const { name, value } = event.target
        setUser({ ...user, [name]: value })
    }


    const validateEmail = (email) => {
        const regX = /^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/;
        return regX.test(String(email).toLowerCase());
    }

    // const validatePhone = (phone) => {
    //     const regX = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    //     return regX.test(phone)
    // }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isEmailValid = validateEmail(user_email)

        if (isEmailValid) {
            await emailjs.sendForm('service_riov1i9', 'template_6h4v6zo', formRef.current, 'user_RwBpa7KRkiALe5CDyRemA')
            setUser(obj)
            swal({
                title: "Successful!",
                text: "Thank you for contact me",
                button: null,
                icon: "success",
                timer: 2000
            })
        }
        else {
            swal({
                title: "Error!",
                text: "Please check your email!",
                icon: "error",
                timer: 5000
            })
        }
    };

    return (
        <ContactFormStyled>
            <div className="contact-title">
                <h4>Get In Touch</h4>
            </div>
            <form className="form" ref={formRef} onSubmit={handleSubmit}>
                <div className="form-field">
                    <label htmlFor="name">Enter your name*</label>
                    <input type="text" name="user_name" onChange={handleChange} value={user_name} />
                </div>
                <div className="form-field">
                    <label htmlFor="email"  >Enter your email*</label>
                    <input type="email" name="user_email" onChange={handleChange} value={user_email} />
                </div>
                <div className="form-field">
                    <label htmlFor="phone">Enter your contact (optional)</label>
                    <input type="number" name="user_phone" onChange={handleChange} value={user_phone} />
                </div>
                <div className="form-field">
                    <label htmlFor="message">Enter your message*</label>
                    <textarea name="message" cols="30" rows="4" onChange={handleChange} value={message} ></textarea>
                </div>
                <div className="form-field f-button">
                    <PrimaryButton title={'Submit'} />
                </div>
            </form>
        </ContactFormStyled>
    )
}

export default ContactForm
